import { observer } from "mobx-react"

const Footer = observer(() => {
    return (<>
        <footer className="bg-gradient text-white text-center py-4">
            <p>Follow Us for More Mischief!</p>
            <div>
                <a href="#" className="btn btn-outline-light btn-sm mx-1">
                    🐦 Twitter
                </a>
                <a href="#" className="btn btn-outline-light btn-sm mx-1">
                    📣 Telegram
                </a>
                <a href="#" className="btn btn-outline-light btn-sm mx-1">
                    👾 Discord
                </a>
            </div>
            <p className="mt-3">© 2025 SnowballBoss. Mischievously Yours!</p>
        </footer>
    </>)
});

export default Footer;